export const transactionTypes = {
    1: 'Innbetaling',
    2: 'Utbetaling',
    3: 'Sjekk',
    4: 'Giro',
    5: 'Inkasso',
    6: 'Diskontering',
    7: 'Iflg. oppgave',
    8: 'Oppdrag',
    9: 'Tilbakeførsel',
    11: 'Innskudd',
    12: 'Uttak',
    13: 'Lønn',
    14: 'Overførsel',
    15: 'Overførsel utland',
    16: 'Skatt',
    17: 'Lodd/gevinst',
    18: 'Husleie',
    19: 'Tilbakebetalt skatt',
    21: 'Manuell overførsel fremmed bank',
    22: 'Dagsoppgjør Nattsafe',
    24: 'Overførsel fra utlandet',
    25: 'Kontingent',
    26: 'AutoGiro, kred.bet.',
    27: 'Moms/avgift',
    29: 'Kuponger',
    30: 'Trygd/pensjon',
    31: 'Hyretrekk',
    32: 'Landbruk',
    33: 'E-verk',
    34: 'Telefon',
    35: 'Forsikring',
    36: 'Lån',
    37: 'Forvaltning',
    38: 'Tinglysing',
    39: 'Boksleie',
    40: 'Verdipapir',
    41: 'Innskudd uten spareavtale',
    50: 'Renter ajourført',
    51: 'Provisjon',
    53: 'Pris',
    54: 'Omkostninger',
    55: 'Barnetrygd',
    56: 'Avtale',
    57: 'Samlegiro',
    58: 'Giro/Avtalegiro',
    59: 'Bankremisse',
    60: 'Meg selv-sjekk',
    61: 'Nattsafe',
    62: 'Kontofon',
    63: 'BrevGiro (privat)',
    64: 'BrevGiro (næring)',
    65: 'Innskudd BSU-konti forrige år',
    66: 'Kontofon-overførsel til 3. part',
    67: 'Giro',
    68: 'Varekjøp/Uttak',
    69: 'Varekjøp/Uttak',
    70: 'Utbetalingsanvisning',
    73: 'Papirbasert reserve-løsning bet.terminal',
    74: 'VISA-minibankuttak utenlandsk kortholder',
    75: 'VISA-minibankuttak utenlandsk kortholder manuell oppretting',
    76: 'VISA-varekjøp utenlandsk kortholder',
    78: 'EuroCard i Minibank',
    79: 'Giro i minibank',
    80: 'Direkte debitering uten gebyr (debet)',
    81: 'Direkte debitering uten gebyr (kredit)',
    82: 'Direkte debitering med gebyr (debet)',
    83: 'Direkte debitering med gebyr (kredit)',
    84: 'Sumpost OCRGiro',
    85: 'Sumpost AutoGiro',
    86: 'Minibank-uttak i europeisk minibank',
    87: 'Europeisk minibank- uttak i Norge',
    88: 'Sumpost EFTPOS fra annen datasentral',
    89: 'Sumpost EFTPOS fra EDB Fellesdata-terminal',
    90: 'Interimstransaksjon reg.bank / kontobank',
    91: 'Avregning Teamco/BBS',
    92: 'Uttrekning fra VPS',
    93: 'Minibank-giro belastet annen konto',
    94: 'Minibank-uttak belastet annen konto',
    95: 'Minibank-overførsel belastet kortkonto',
    96: 'Minibank-overførsel belastet annen konto',
    97: 'Minibank-overførsel kredit egen konto',
    99: 'Minibank-overførsel til 3. mann',
    101: 'Standard giro Forfallsregister',
    102: 'Billig giro Forfallsregister',
    103: 'Postgiro Forfallsregister',
    104: 'Advisert giro Forfallsregister',
    105: 'Generelt oppdrag Forfallsregister',
    106: 'Generell overførsel Forfallsregister',
    110: 'Betalt terminomk. v/undertrykt giro/belastning',
    111: 'Bet. varselomkostninger giro',
    112: 'Bet. forsikringsprov.',
    113: 'Bet. diverse omk. Ikke fradragsberettiget',
    114: 'Bet. purreomk. 1.',
    115: 'Bet. purreomk. 2.',
    116: 'Bet. purreomk. 3.',
    117: 'Bet. endringsomkostn.',
    118: 'Bet. direkte utlegg rettsgebyr o.l.',
    119: 'Bet. depotomkostn.',
    120: 'Bet. betalings-oppfordringsomk.',
    121: 'Bet.varselomkost-ninger m/oppgave',
    122: 'Bet. varselomkost-ninger m/oppgave',
    123: 'Bet. omkostninger v/manglende dekning',
    124: 'Bet. diverse omkostninger.',
    125: 'Bet. henstandsrente',
    126: 'Kap. henstandsrente',
    127: 'Bet. direkte utlegg andre',
    128: 'Endelig ettergivelse av kapitalsaldo',
    129: 'Betinget ettergivelse av kapitalsaldo',
    130: 'Bet. rente',
    131: 'Bet.rente ved for sen betaling',
    132: 'Dødsrisiko-forsikringspremie',
    133: 'Uføre-forsikringspremie',
    134: 'Ulykkes-forsikringspremie',
    135: 'Morarente',
    136: 'Betaling av overkurs',
    137: 'Kap. endrings-omkostninger',
    138: 'Bet. terminomk.v/ undertrykt giro/belastning',
    139: 'Kap. depotomkostn.',
    140: 'Kap.betalings-oppford. kost.',
    141: 'Kap. varselomkostn. m/oppgave',
    142: 'Kap. varselom-kostninger u/oppgave',
    143: 'Kap. omkostninger v/manglende dekning',
    144: 'Kap. diverse omkostn.',
    145: 'Bet. diverse omkostn. Ikke fradragsber..',
    146: 'Bet. direkte utlegg rettsgebyr e.l.',
    147: 'Kap. rente v.for sen betaling',
    148: 'Kap. overkurs',
    149: 'Bet. direkte utlegg andre',
    150: 'Innskudd m/ regulering av bevilgning',
    151: 'Minibank',
    152: 'Saldoforespørsel minibank innenfor eget konsern',
    153: 'Saldoforespørsel minibank utenfor eget konsern',
    154: 'Avslutning av konto for tapsføring av utestående',
    155: 'AutoGiro',
    156: 'Avtalegiro',
    157: 'Igangsatt Avtalegiro',
    158: 'Belastn. VPS-gebyr',
    159: 'Innsamlingsgiro',
    160: 'Giro',
    161: 'Giro m/KID',
    162: 'TeleGiro til 3. mann',
    163: 'Giro m/melding',
    164: 'Giro m/melding',
    165: 'Overf. m/melding fra DSGR',
    166: 'Overførsel med melding fra SparNett',
    167: 'Overføring',
    168: 'Overføring',
    178: 'Reg. saldo underkonto tilleggsbevilgning',
    179: 'Reg. saldo underkonto. ordinær bevilgning',
    180: 'Korr. konto i KKS',
    181: 'Justering av dagsom-setningsverdi NOK',
    194: 'VISA Electron',
    197: 'Straksbetaling',
    200: 'Overføring',
    201: 'Giro m/KID',
    202: 'Giro m/KID',
    203: 'Giro m/melding',
    204: 'Giro m/melding',
    205: 'Overføring',
    206: 'Overføring',
    207: 'Overføring',
    220: 'Alternativ fordeling Kombinasjonssparing',
    221: 'Ingen fordeling Kombinasjonssparing',
    222: 'Ordinær fordeling Kombinasjonssparing',
    223: 'Alt. fordeling Kombinasjonssparing',
    224: 'Flytting av kapital innen spareavtale Kombinasjonssparing',
    225: 'Innløsning i fond Kombinasjonssparing',
    226: 'Utbetaling fra spareavtale Kombinasjonssparing',
    227: 'Reinvestering IPA-avtale Kombinasjonssparing',
    228: 'Innskudd ifjor IPA Kombinasjonssparing',
    229: 'Tilbf. innskudd ifjor Kombinasjonssparing',
    230: 'Overføring av IPA Kombinasjonssparing',
    231: 'Avsl. IPA død/eng. Kombinasjonssparing',
    232: 'Rateutbetaling Kombinasjonssparing',
    233: 'Tilbakeføring av kapitaliserte renter Kombinasjonssparing',
    234: 'Tilbakeføring av kapitaliserte gebyrer Kombinasjonssparing',
    235: 'Flytting IPA Kombinasjonssparing',
    236: 'Flytting IPA - begunstiget Kombinasjonssparing',
    237: 'Innskudd i utbetalingsperioden Kombinasjonssparing',
    238: 'Arveoppgjør til begunstiget',
    239: 'Innskudd i fjor',
    240: 'Betaling av ordinær rente trinn 2',
    241: 'Betaling av ordinær rente trinn 3',
    242: 'Betaling av forskudds-rente. ordinær rente.',
    243: 'Betaling av for-skuddsrente. premie dødsrisikoforsikring',
    244: 'Betaling av for-skuddsrente. premie uføreforsikring',
    245: 'Betaling av for-skuddsrente. premie ulykkesforsikring',
    246: 'Betaling rentetype 713',
    247: 'Kapitalisering rentetype 713',
    248: 'Betaling AvtaleGiro-omkostninger',
    249: 'Betaling rentegaranti- rentetype 714',
    250: 'Etableringsomkostn.',
    251: 'Depotomkostninger',
    252: 'Diverse omkostninger',
    253: 'Diverse omkostninger',
    254: 'Dir. utlegg rettsomk.',
    255: 'Direkte utlegg',
    260: 'Overførsel mellom egne konti i MobilBank, forfall i dag',
    261: 'MobilGiro m/KID, til forfall i dag',
    262: 'MobilGiro m/melding, til forfall',
    263: 'MobilGiro m/melding, forfall i dag',
    264: 'MobilGiro m/melding, til forfall',
    265: 'Overførsel mellom egne konti i MobilBank, til forfall',
    266: 'Overførsel mellom egne konti - predefinert 3. mann i MobilBank, forfall i dag',
    267: 'Overførsel mellom egne konti - predefinert 3. mann i MobilBank, til forfall',
    280: 'Reinvestert IPA avtale',
    281: 'Tilbakeføring av utbetalt beløp i år',
    282: 'Tilbakeføring av utbetalt beløp i fjor',
    300: 'Renter',
    301: 'Overførsel utland',
    302: 'Gebyrfri overførsel',
    303: 'Deposit',
    304: 'Kontoregulering',
    305: 'Arbitrasje',
    306: 'Valuta overførsel',
    308: 'Tilbakeførsel',
    309: 'Tilbakeførsel sjekker',
    310: 'Utenlandsk sjekk',
    311: 'Terminforretning',
    312: 'Gebyr',
    313: 'Korreksjon',
    317: 'Dokumentinkasso utland',
    318: 'Vekselinkasso utland',
    321: 'Ubekreftet remburs',
    323: 'Renteswap',
    324: 'Rentevaluta-swap',
    325: 'Futures',
    326: 'Opsjoner',
    327: 'Diskontering og innbet. av lån i SysCon',
    500: 'e-Faktura NettBank m/KID',
    501: 'e-Faktura NettBank m/melding',
    502: 'e-Faktura WAP m/KID',
    503: 'e-fFktura WAP m/melding',
    504: 'e-Faktura AvtaleGiro',
    505: 'e-Faktura AvtaleGiro kreditorbetalt',
    510: 'Kreditorbetalt AvtaleGiro',
    511: 'Overføring',
    512: 'Fondsandeler',
    513: 'Lading av pengekort',
    514: 'Tilbakeføring av pengekort',
    515: 'Pengekort, oppgjør butikk',
    516: 'Varekjøp internett',
    517: 'Oppgjør internett',
    520: 'Bedriftsterminal oppgave',
    521: 'Bedriftsterminal overførsel',
    544: 'Overføring',
    546: 'Overføring',
    561: 'Vipps straksbet.',
    600: 'Kapitalisering AvtaleGiro-omkostninger',
    601: 'Kapitalisering rentegaranti-rentetype 714',
    702: 'MasterCard kontantuttak',
    703: 'Gjensidige Bank (spor2-kort)',
    704: 'GE Kapital (spor2-kort)',
    705: 'Eurosjekk-kontantuttak. (kort)',
    708: 'Visa',
    709: 'Varekjøp',
    710: 'Varekjøp',
    712: 'Eurosjekk',
    713: 'Tilbakeført Eurosjekk',
    714: 'Visa',
    715: 'Visa',
    716: 'Innskudd ajourført',
    717: 'Uttak ajourført',
    718: 'Minibank',
    719: 'Minibank',
    721: 'Varekjøp (Posten)',
    722: 'Ekstraord. innbetaling m/reg. av bevilgning',
    723: 'Tilbakeføring ekstra-ordinær bevilgning',
    724: 'Varekjøp Postbankkort',
    725: 'Minibank med Postens minibankkort',
    726: 'Uttak uten gebyr',
    727: 'Uttak med gebyr',
    728: 'Avslutning u/gebyr',
    729: 'Avslutning av konto',
    735: 'Fast oppdrag',
    737: 'Konto åpnet i Servo',
    739: 'Overføring',
    740: 'Dødsrisiko-forsikringspremie',
    741: 'Uføre-forsikringspremie',
    742: 'Ulykkes-forsikringspremie',
    743: 'Strafferente kreditt/ VISA Gold',
    744: 'Debet rente',
    745: 'Kredit rente',
    747: 'Ordinær rente trinn 2',
    748: 'Debetrente bruksdel',
    749: 'Debetrente ord. bev.',
    750: 'Debetrente terskel',
    751: 'Debetrente',
    752: 'Kreditrente',
    753: 'Terskelrente',
    754: 'Terskelrente 2',
    755: 'Terskelrente 3',
    756: 'Tilleggsprovisjon',
    757: 'Utnyttelsesprovisjon',
    758: 'Overtrekksprovisjon',
    759: 'Ordinær provisjon',
    760: 'Avgift',
    761: 'Trans.gebyr VISA',
    762: 'Årsomk Visa',
    763: 'Garantiprovisjon',
    765: 'Betalt etabl.gebyr',
    766: 'Forsikringsprovisjon',
    767: 'Terskelrente 4',
    768: 'Omk. m/korr. av purre-statistikk. Krever ref-felt med 1. , 2. og/eller 3. purring',
    769: 'Omkostninger',
    770: 'Saldooverførsel',
    771: 'Saldooverførsel',
    773: 'Korr. saldo avregningskonto 00.97918',
    774: 'Korreksjon saldo',
    775: 'Korr. saldo samlekonto. + for renter og prov.',
    776: 'Terskelrente 5',
    791: 'Flerkonto-terskelrente 2',
    792: 'Høyrente bruksdel',
    793: 'flerkonto-rente',
    794: 'Årsbonus',
    795: 'Uttaksgebyr',
    796: 'Utnyttelsesprovisjon 2',
    797: 'Over-/underkurs fastrente',
    798: 'Bonusrente',
    799: 'Flerkonto-terskelrente 3',
    800: 'Reg.rente ved for sen betaling',
    801: 'Regulering morarente',
    802: 'Regulering henstandsrente',
    803: 'Endelig ettergivelse av ordinær rente',
    804: 'Endelig ettergivelse av forsinkelsesrente',
    805: 'Betinget ettergivelse av ordinær rente',
    806: 'Betinget ettergivelse av forsinkelsesrente',
    807: 'Reg. av ordinær rente trinn 2',
    808: 'Reg. av ordinær rente trinn 3',
    830: 'Kapitalisering renter',
    831: 'Kapitalisering debetrente',
    832: 'Kapitalisering kredittrente',
    839: 'Kapitalisering ordinær provisjon',
    843: 'Strafferente kreditt/ VISA Gold',
    845: 'Dødsrisiko-forsikringspremie',
    846: 'Uførekapitalpremie',
    847: 'Ulykkesforsikring',
    848: 'Debet rentesaldo bruksdel',
    849: 'Debet rentesaldo ordinær bevilgning',
    850: 'Debetrente terskel',
    851: 'Debet rentesaldo tilleggsbevilgning',
    852: 'Kreditrentesaldo',
    853: 'Terskelrentesaldo',
    854: 'Terskelrentesaldo 2',
    855: 'Terskelrentesaldo 3',
    858: 'Overtrekksprov. saldo',
    859: 'Provisjon saldo ord.',
    860: 'Renteregulering rentestøtte',
    861: 'Regulering rentegaranti',
    867: 'Terskelrentesaldo 4',
    876: 'Terskelrentesaldo 5',
    879: 'Innløsning ord. bev.',
    891: 'Flerkonto-terskelrentesaldo 2',
    892: 'Uttaksgebyr fastrente',
    893: 'Flerkonto-rente',
    895: 'Uttaksgebyr',
    896: 'Utnyttelsesprov. 2',
    897: 'Over-/underkurs fastrente',
    898: 'Bonusrente',
    899: 'Flerkonto-terskelrentesaldo 3',
    901: 'Innbetaling',
    902: 'Utbetaling',
    903: 'Sjekk',
    904: 'Giro',
    905: 'Inkasso',
    909: 'Tilbakeførsel',
    911: 'Innskudd',
    912: 'Uttak',
    913: 'Lønn',
    914: 'Overførsel',
    921: 'Bekreftelse sjekk i BALTUS',
    922: 'Minibank',
    923: 'Varekjøp',
    924: 'Minibank',
    925: 'Bekreftelse giro i BALTUS',
    926: 'Bekreftelse valuta i BALTUS',
    927: 'Bekreftelse fondsandeler og finansielle tjenester i BALTUS',
    928: 'Bekreftelse bedriftsterminal',
    930: 'Bekreftet AutoGiro',
    931: 'Bekreftet BrevGiro',
    932: 'Bekreftet sumpost direkte remittering',
    933: 'Bekreftet AvtaleGiro',
    937: 'Bekreftelse varekjøp internett',
    938: 'Minibank',
    939: 'Bekreftelse Baltus Pengekort',
    941: 'Bekreftet uttak i europeisk minibank',
    942: 'Tilbakeført bekreftelse uttak i europeisk minibank',
    943: 'Varekjøp',
    944: 'Verdipapirhandel',
    945: 'Minibank',
    946: 'Bekreftet VISA',
    947: 'Bekreftet MasterCard',
    948: 'Tilbakeført bekreftelse i BALTUS',
    949: 'Tilbakeføring av bekreftelse VISA',
    950: 'Reservasjon',
    960: 'Straksbetaling',
    962: 'Vipps straksbet.',
};
